import { T_Admin } from "@/app/translations/all/T_Admin";
import { T_Common } from "@/app/translations/all/T_Common";
import { T_Configurator } from "@/app/translations/all/T_Configurator";
import { T_Emails } from "@/app/translations/all/T_Emails";
import { T_Errors } from "@/app/translations/all/T_Errors";
import { T_Footer } from "@/app/translations/all/T_Footer";
import { T_ForgotPassword } from "@/app/translations/all/T_ForgotPassword";
import { T_Header } from "@/app/translations/all/T_Header";
import { T_LogIn } from "@/app/translations/all/T_LogIn";
import { T_Pro } from "@/app/translations/all/T_Pro";
import { T_Settings } from "@/app/translations/all/T_Settings";
import { TKey } from "@/app/translations/TKey";
import { INVERTED_Languages_MIN } from "@/app/vars/Languages";

export interface TranslationsType {
  [key: string]: {
    EN_US: string;
    FR_FR: string;
  };
}

export const Translations: TranslationsType = {
  ...T_Header,
  ...T_Footer,
  ...T_LogIn,
  ...T_ForgotPassword,
  ...T_Configurator,
  ...T_Emails,
  ...T_Errors,
  ...T_Common,
  ...T_Admin,
  ...T_Pro,
  ...T_Settings,
};

export function T(key: TKey, lang: any): string | TKey {
  const _lang = INVERTED_Languages_MIN[lang];
  const translationObject: any = Translations[key];

  if (translationObject && translationObject[_lang]?.trim().length > 0) {
    return translationObject[_lang];
  }

  return key;
}

export function TErrors(errors: any, lang: string): any {
  if (typeof errors === "string") {
    return T(errors as TKey, lang);
  }

  if (Array.isArray(errors)) {
    return errors.map((item) => TErrors(item, lang));
  }

  if (typeof errors === "object" && errors !== null) {
    const translated: any = {};
    for (const key in errors) {
      translated[key] = TErrors(errors[key], lang);
    }
    return translated;
  }

  return errors;
}
